import { useId } from 'react';
import { Button, Form, Table } from 'react-bootstrap';

/**
 * The tests the doctor wants done, each with the clinic to get it done at.
 * One patient may be sent to two different places on the same sheet, so the
 * clinic is chosen per line rather than once for the whole prescription.
 */
export default function TestsAdvised({ value = [], onChange, clinics = [], suggestions = [] }) {
  const listId = useId();
  const rows = value.length ? value : [{ name: '', referralClinic: '' }];

  function setRow(index, next) {
    onChange(rows.map((r, i) => (i === index ? next : r)));
  }

  function addRow() {
    onChange([...rows, { name: '', referralClinic: '' }]);
  }

  function removeRow(index) {
    const left = rows.filter((_, i) => i !== index);
    onChange(left.length ? left : [{ name: '', referralClinic: '' }]);
  }

  return (
    <>
      <datalist id={listId}>
        {suggestions.map((s) => (
          <option key={s} value={s} />
        ))}
      </datalist>

      <Table size="sm" className="mb-2 align-middle test-table">
        <thead>
          <tr>
            <th>Test</th>
            <th>Get it done at</th>
            <th style={{ width: 40 }} />
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              <td>
                <Form.Control
                  size="sm"
                  list={listId}
                  value={row.name}
                  placeholder="e.g. CBC"
                  onChange={(e) => setRow(i, { ...row, name: e.target.value })}
                  onKeyDown={(e) => {
                    // Enter on the last line starts another, like the medicines.
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      if (i === rows.length - 1 && row.name.trim()) addRow();
                    }
                  }}
                />
              </td>
              <td>
                <Form.Select
                  size="sm"
                  value={row.referralClinic || ''}
                  onChange={(e) => setRow(i, { ...row, referralClinic: e.target.value })}
                >
                  <option value="">Not referred anywhere</option>
                  {clinics.map((c) => (
                    <option key={c._id} value={c._id}>
                      {c.name}
                      {c.address ? ` - ${c.address}` : ''}
                    </option>
                  ))}
                </Form.Select>
              </td>
              <td>
                <Button
                  size="sm"
                  variant="outline-danger"
                  className="btn-icon"
                  onClick={() => removeRow(i)}
                  title="Remove this test"
                >
                  <i className="bi bi-trash" />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Button size="sm" variant="outline-primary" onClick={addRow}>
        <i className="bi bi-plus-lg me-1" /> Add Test
      </Button>

      {clinics.length === 0 && (
        <Form.Text className="text-muted d-block mt-2">
          No clinics on the list yet - add them under Referral Clinics in the sidebar.
        </Form.Text>
      )}
    </>
  );
}
